export const panelDeviceName = (UOSName, uosNumber) => {
  const entry = (UOSName ?? [])[Number(uosNumber) - 1];

  return typeof entry === 'string' ? entry.slice(1) : '';
};
